import {t} from "@lingui/core/macro";

export const digitalSatTarget = "/test-prep/digital-sat";

type LandingPageOptions = {
    confirmed: boolean;
};

function landingPageUrl(base: string, {confirmed}: LandingPageOptions): string {
    return `${base}${confirmed ? "/confirmed" : ""}`;
}

export function digitalSatLandingPage(options: LandingPageOptions): string {
    return landingPageUrl("/digital-sat", options);
}

export const digitalSatInsideScoopUrl: string =
    "https://satsuite.collegeboard.org/digital?excmpid=pt003-st-1-ka";

export const digitalSatCoachUrl: string =
    "https://satsuite.collegeboard.org/digital/digital-practice-preparation?excmpid=pt003-st-2-ka";

export const getSatPrepSunsetFaqUrl = () =>
    t`https://support.khanacademy.org/hc/en-us/articles/17921365165581`;
